import { t } from 'i18next';

import { ErrorResponseErrorItemCodePointCloud } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodePointCloud, string> => ({
  'pointcloud:not_found_in_project': t('pointCloud.notFoundInProject', {
    ns: 'apiErrorCodes',
    defaultValue: 'Punktmolnet hittades inte i projektet.',
  }),
});
